import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

// third-party
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useSelector } from "react-redux";

// application
import Pagination from '../shared/Pagination';

// data stubs
import theme from '../../data/theme';
import shopApi from "../../api/shop";
import { formatDate } from "../../services/utils";

const AccountPageOrders = () => {
    const [page, setPage] = useState(1);
    const [response, setResponse] = useState(null);

    const user = useSelector((state) => state.user);
    const userId = user?.userConnected?.user?.id;

    useEffect(() => {
        shopApi.getUserOrders(userId, page).then((res) => {
            setResponse(res);
        });
    }, [userId, page]);

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const ordersList = response?.orders?.map((order) => {    
        return (
            <tr key={order?.id}>
                <td><Link to={`/account/orders/${order?.id}`}>{`#${order?.id}`}</Link></td>
                <td>{formatDate(order?.dateOrdered)}</td>
                <td>${order?.totalPrice}</td>
            </tr>
        );
    });
    

    return (
        <div className="card">
            <Helmet>
                <title>{`Order History — ${theme.name}`}</title>
            </Helmet>

            <div className="card-header">
                <h5><FormattedMessage id="Account.orderHistory" defaultMessage="Order History" /></h5>
            </div>
            <div className="card-divider" />
            <div className="card-table">
                <div className="table-responsive-sm">
                    <table>
                        <thead>
                            <tr>
                                <th><FormattedMessage id="Account.order" defaultMessage="Order" /></th>
                                <th><FormattedMessage id="Account.date" defaultMessage="Date" /></th>
                                <th><FormattedMessage id="Account.total" defaultMessage="Total" /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {ordersList}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="card-divider" />
            <div className="card-footer">
            <Pagination
                current={response?.currentPage}
                total={response?.totalPages}
                onPageChange={handlePageChange}
            />           
             </div>
        </div>
    );
};

export default AccountPageOrders;
